'use strict';

import logo from './logo.mjs';
import animationsUtility from '../utility/animations.js';

let isMegaMenuOpen = false;

const navActiveShortcuts = () => {
    const uri = window.location.pathname;
    document.querySelectorAll('nav').forEach(navigation => {
        navigation.querySelectorAll('a').forEach(link => {
            if (link.getAttribute('href') === uri) {
                link.parentElement.classList.add('active');
                link.parentElement.classList.remove('normal');
            }
        });
    });
};

const initMegaMenu = () => {
    isMegaMenuOpen = false;
    const megaMenuTrigger = document.querySelector('.mega-menu-trigger');
    const megaMenu = document.querySelector('.tc-website-megamenu');
    const closeMenuTrigger = megaMenu.querySelector('.close-mega-menu');

    if (!megaMenu || !megaMenuTrigger || !closeMenuTrigger) {
        return;
    }

    resetCursor()
    animationsUtility.initMegaMenu(megaMenu)

    megaMenuTrigger.addEventListener('click', () => {
        if (!isMegaMenuOpen) {
            openMegaMenu(megaMenu);
        }
    });

    closeMenuTrigger.addEventListener('click', () => {
        if (isMegaMenuOpen) {
            closeMegaMenu(megaMenu);
        }
    });

    // Detect Safari to avoid scroll issues
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    if (!isSafari) {
        // Resize handler only on non-Safari browsers
        window.addEventListener('resize', () => {
            if (isMegaMenuOpen) {
                if (window.innerWidth > 1399) {
                    disableCursorDetection();
                    logo.animateMegaMenuLogo(true);
                    document.body.classList.remove('gray-cursor');
                }
            }
        });
    }
};

const onKeyDown = (event, megaMenu) => {
    if (event.key === 'Escape' || event.key === 'Esc') {
        if (isMegaMenuOpen) {
            closeMegaMenu(megaMenu);
        }
    }
};

const openMegaMenu = (megaMenu) => {
    document.documentElement.classList.add('mega-menu-opened')
    document.body.classList.remove('green-cursor')
    document.body.classList.add('gray-cursor')

    animationsUtility.openMegaMenu(megaMenu, () => {
        logo.animateMegaMenuLogo()
        enableCursorDetection()
        isMegaMenuOpen = true
        document.body.classList.add('mega-menu-opened')
        document.addEventListener('keydown', (e) => onKeyDown(e, megaMenu));
    })
};

const closeMegaMenu = (megaMenu) => {
    document.documentElement.classList.remove('mega-menu-opened')
    disableCursorDetection()

    setTimeout(() => {
        document.body.classList.remove('gray-cursor');
        document.body.classList.add('green-cursor');
    }, 600)

    animationsUtility.closeMegaMenu(megaMenu, () => {
        logo.animateMegaMenuLogo(true)
        isMegaMenuOpen = false
        document.body.classList.remove('gray-cursor')
        document.body.classList.add('green-cursor')
        document.removeEventListener('keydown', (e) => onKeyDown(e, megaMenu));
    })
}

const onMouseMove = (event) => {
    const megaMenuRight = document.querySelector('.mega-menu-right');
    const rectRight = megaMenuRight.getBoundingClientRect();
    const hoveredElement = document.elementFromPoint(event.clientX, event.clientY);
    const tagName = hoveredElement?.tagName;

    if (hoveredElement && (tagName === 'A' || tagName === 'LI') && hoveredElement.closest('.mega-menu-right')) {
        document.body.classList.remove('green-cursor');
        document.body.classList.add('gray-cursor');
        return;
    }

    if (event.clientX >= rectRight.left) {
        document.body.classList.remove('green-cursor');
        document.body.classList.add('gray-cursor');
    } else {
        document.body.classList.remove('gray-cursor');
        document.body.classList.add('green-cursor');
    }
};

const enableCursorDetection = () => {
    document.addEventListener('mousemove', onMouseMove);
};

const disableCursorDetection = () => {
    document.removeEventListener('mousemove', onMouseMove);
};

const resetCursor = () => {
    disableCursorDetection()
    document.body.classList.remove('green-cursor')
    document.body.classList.remove('gray-cursor')
}

export default {navActiveShortcuts, initMegaMenu, openMegaMenu, closeMegaMenu};
